import { render } from "./LoadNuwall.vue?vue&type=template&id=777b6924"
import script from "./LoadNuwall.vue?vue&type=script&lang=js"
export * from "./LoadNuwall.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__